import { formatDecimal } from 'framework/utils';
import { Badge, Tooltip } from 'framework/ui/mui-builder';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { ChipOwnProps } from '@mui/material';

const FTEBadge = ({ isMemberFter, assignedFteSource, minPercentSource, maxPercentSource, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper<number>(props as any);
  const { getValue: getAssignedFte } = useFieldHelper<number>({ source: assignedFteSource } as any);
  const { getValue: getMinPercent } = useFieldHelper<number | string>({ source: minPercentSource } as any);
  const { getValue: getMaxPercent } = useFieldHelper<number | string>({ source: maxPercentSource } as any);

  const fteValue = getValue();
  const assignedFteValue = getAssignedFte();

  const formattedFte = typeof fteValue === 'number' ? formatDecimal(fteValue) : formatDecimal(fteValue || 0);

  const getColor = (): ChipOwnProps['color'] => {
    if (isMemberFter) {
      return 'default';
    }

    return Number(fteValue) !== Number(assignedFteValue) ? 'error' : 'success';
  };

  const badge = <Badge color={getColor()}>{formattedFte} FTE</Badge>;

  const minPercentRaw = minPercentSource ? getMinPercent() : undefined;
  const maxPercentRaw = maxPercentSource ? getMaxPercent() : undefined;
  const minPercent = Number(minPercentRaw);
  const maxPercent = Number(maxPercentRaw);
  const hasAllocationRange =
    minPercentRaw != null && maxPercentRaw != null && Number.isFinite(minPercent) && Number.isFinite(maxPercent);

  if (!hasAllocationRange) {
    return badge;
  }

  return (
    <Tooltip title={`${minPercent}–${maxPercent}%`}>
      <span>{badge}</span>
    </Tooltip>
  );
};
export default FTEBadge;
